import {ApiResponse} from '../CommonInterfaces';
import InternalAPIService from './InternalAPIService';

class UserBarService extends InternalAPIService {
  constructor(authenticityToken: string) {
    super(authenticityToken, '/api/user-bar');
  }

  public getUserBarSettings(): Promise<ApiResponse<UserBarData>> {
    return this.makeGetRequest(this.baseUrl);
  }
}

export default UserBarService;

export interface UserBarData {
  isShipper: boolean;
  userDetails: UserDetails;
  warehouseSelector: WarehouseSelector;
}

export interface UserDetails {
  userName: string;
  changePasswordPath: string;
  logOutPath: string;
}

export interface WarehouseSelector {
  activeWarehouses: Warehouse[];
  selectedWarehouse?: Warehouse;
}

export interface Warehouse {
  id: number;
  name: string;
}
